import Swal from 'sweetalert2';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import SourceIcon from '../icons/source.svg';

import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';

export default class SourceCode extends Plugin {
    static get requires() {
        return [MediaEmbed];
    }

    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('sourcearea', (locale) => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Mostrar HTML fonte',
                icon: SourceIcon,
                tooltip: true,
            });
            view.on('execute', async () => {
                await Swal.fire({
                    text: 'HTML Fonte',
                    input: 'textarea',
                    inputValue: editor.getData(),
                    showCancelButton: true,
                    confirmButtonText: 'Salvar as alterações!',
                    cancelButtonText: 'Não salvar as alterações!'
                }).then((data) => {
                    editor.setData(data.value)
                })
            });
            return view;
        });
    }
}
